import {FC} from 'react'
import {TableBookingAppWrapper} from '../tables/TableBookingApp'

const HeaderBookingAppPanel: FC = () => {
  return (
    <>
      <TableBookingAppWrapper />
    </>
  )
}

export {HeaderBookingAppPanel}
